import { useRef } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    useIonAlert,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
    IonTextarea,
    IonCheckbox,
    IonIcon
} from '@ionic/react';
import { addSmsTemplate, deleteSmsTemplate, setSmsTemplate } from '../firebase/smsTemplates';
import { checkmark, chevronBack } from 'ionicons/icons';

const SmsTemplateEditor = ({
    onDismiss,
    template
}: {
    onDismiss: () => void,
    template: any
}) => {

    const [presentAlert] = useIonAlert();

    const topicRef = useRef<HTMLIonInputElement>(null);
    const defaultRef = useRef<HTMLIonCheckboxElement>(null);
    const reminderRef = useRef<HTMLIonCheckboxElement>(null);
    const senderRef = useRef<HTMLIonInputElement>(null);
    const textRef = useRef<HTMLIonTextareaElement>(null);
    const isNew = template.id === undefined;

    function confirm() {
        var data = { default: defaultRef.current?.checked ?? false, reminder: reminderRef.current?.checked ?? false, sender: senderRef.current?.value ?? '', text: textRef.current?.value ?? '', topic: topicRef.current?.value ?? '' }
        if (isNew) {
            addSmsTemplate(data);
        } else {
            setSmsTemplate(data, template.id);
        }
        onDismiss();
    }



    function remove() {
        presentAlert({
            header: 'Usuwanie!',
            buttons: [
                {
                    text: 'Anuluj',
                    role: 'cancel'
                },
                {
                    text: 'Usuń',
                    role: 'confirm',
                },
            ],
            onDidDismiss: (e: CustomEvent) => {
                if (e.detail.role === 'confirm') {
                    deleteSmsTemplate(template.id);
                    onDismiss();
                }
            },
        })

    }

    function cancel() {
        onDismiss();
    }


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => cancel()}>
                            <IonIcon icon={chevronBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{isNew ? "Nowy szablonu" : "Edycja szablonu " + template.topic}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent style={{ height: '100%' }} className="ion-padding">
                <IonItem>
                    <IonLabel position="fixed">Nazwa</IonLabel>
                    <IonInput placeholder="Nazwa" ref={topicRef} value={template.topic} ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Domyślny</IonLabel>
                    <IonCheckbox ref={defaultRef} checked={template.default}></IonCheckbox>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Przypomnienie</IonLabel>
                    <IonCheckbox ref={reminderRef} checked={template.reminder}></IonCheckbox>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Nadawca</IonLabel>
                    <IonInput placeholder="Nadawca" ref={senderRef} value={template.sender} ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel position="floating">Treść (zmienne [DATA] [CZAS])</IonLabel>
                    <IonTextarea placeholder="Treść" autoGrow={true} ref={textRef} value={template.text} ></IonTextarea>
                </IonItem>
            </IonContent>
            <IonFooter>
                {!isNew && template.topic === "" ? <div><IonButton size="small" color="danger" onClick={() => remove()}>usuń</IonButton><br/><br/></div> : ""}
            </IonFooter>
        </IonPage>
    );
};

export default SmsTemplateEditor;

